import { configureStore } from "@reduxjs/toolkit";

// reducers
import news from "./slices/news";
import certificates from "./slices/certificates";
import stroyVagon from "./slices/stroyvagon";
import telejka from "./slices/telejka";
import complect from "./slices/complect";
import _import from "./slices/import";
import members from "./slices/members";
import docs from "./slices/docs";
import history from "./slices/history";
import vacancies from "./slices/vacancies";
import subjectAndGoals from "./slices/subjectAndGoals";
import contacts from "./slices/contacts";
import tradeUnion from "./slices/tradeUnion";
import structure from "./slices/sturcture";
import fond from "./slices/fond";
import corDocs from "./slices/corDocs";
import corTitleDocs from "./slices/corTitleDocs";
import virtours from "./slices/virtour";
import purchaseList from "./slices/purchaseLits";
import lang from "./slices/lang";
import vote from "./slices/vote";
import announcements from "./slices/announcements";
import media from "./slices/media";

export const store = configureStore({
  reducer: {
    news,
    stroyVagon,
    telejka,
    complect,
    certificates,
    _import,
    members,
    docs,
    history,
    vacancies,
    subjectAndGoals,
    contacts,
    tradeUnion,
    structure,
    fond,
    corDocs,
    corTitleDocs,
    virtours,
    purchaseList,
    lang,
    vote,
    announcements,
    media,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: process.env.NODE_ENV !== "production",
});
